import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';
import type {
  OtpRequest,
  OtpSentResponse,
  PasswordLoginRequest,
  PasswordResetRequest,
  RegistrationForm,
  SessionProfile,
} from '../types/auth.types';

export const passwordLogin = async (body: PasswordLoginRequest): Promise<SessionProfile> => {
  return await request.post(`${URLS.BACK_DSH}${APIS.passwordLogin}`, body);
};

/** Sends a WhatsApp (or SMS) code; the request is checked first (form, phone number). */
export const requestOtp = async (
  body: OtpRequest & { turnstile_token: string }
): Promise<OtpSentResponse> => {
  return await request.post(`${URLS.BACK_DSH}${APIS.otpRequest}`, body);
};

/** Marks the phone number of this session verified when the code matches. */
export const verifyOtp = async (code: string): Promise<void> => {
  await request.post(`${URLS.BACK_DSH}${APIS.otpVerify}`, { code });
};

/** Creates the account for the verified phone number and signs it in. */
export const register = async (body: RegistrationForm): Promise<SessionProfile> => {
  return await request.post(`${URLS.BACK_DSH}${APIS.register}`, body);
};

export const resetPassword = async (body: PasswordResetRequest): Promise<void> => {
  await request.post(`${URLS.BACK_DSH}${APIS.resetPassword}`, body);
};
